/*
 * @Author: xiaoguanghua
 * @Date: 2024-02-29
 * @FilePath: /diversion-h5/src/main.js
 */
import Vue from 'vue';
import App from './App';
import { router } from './router';
import axiosAjax from '@/libs/http-axios';
import util from '@/libs/util';

import 'amfe-flexible';
import '../src/css/base.css'

Vue.prototype.$http = axiosAjax
Vue.prototype.util = util
new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
